// extracted by mini-css-extract-plugin
export default {"paginationInfo":"style_paginationInfo__W0ZjI"};